
import {StyleSheet} from 'react-native';

const dropdownStyles = StyleSheet.create({
  dropdownActiveButton: {
    border: '1px solid gray',
    borderRadius: 8,
    paddingTop: 2
  },
  button: {
    maxWidth: '107%',
    backgroundColor: '#262B30',
    marginLeft: '-1px'
  },
  dropdownWrapper: {
    borderTopWidth: 2,
    borderTopColor: 'rgb(0, 0, 0)',
    borderStyle: 'solid',
    marginTop: '1rem'
  },
  buttonContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  text: {
    color: '#9BA7B4',
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 13,
    padding: 5
  },
  icon: {
    width: 15,
    height: 15,
    marginRight: '4%',
    marginTop: '1.5%',
    transition: 'transform 0.3s ease'
  },
  iconOpen: {
    transform: [{rotate: '180deg'}]
  },
  customTouchable: {
    paddingLeft: 5
  },
  customTouchableContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'baseline'
  },
  customTouchableCount: {
    color: 'white',
    width: '16%',
    fontSize: 12,
    textAlign: 'right'
  },
  customTouchableText: {
    color: 'white',
    paddingBottom: 2,
    fontSize: 15,
    paddingLeft: 10,
    width: '65%',
    marginLeft: '1%',
    fontFamily: 'Poppins_300Light',
    marginBottom: 2
  },
  customTouchableReset: {
    marginHorizontal: '1%'
  },
  customTouchableIcon: {
    fontSize: 15,
    color: 'gray'
  },
  showAllButton: {
    width: '97%',
    borderColor: 'gray',
    borderWidth: 1,
    borderRadius: 10
  },
  showAllButtonText: {
    textAlign: 'center',
    color: 'white',
    padding: 5
  },
  dropdownContent: {
    marginTop: 5
  },
  includeTagsText: {
    marginLeft: 10,
    fontSize: 11
  },
  notAssignedStyle: {
    color: '#45d797',
    fontSize: 14
  },
  toggleContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  toggleLabel: {
    color: '#fff',
  },
  toggleButton: {
    borderWidth: 1,
    borderColor: 'rgb(69, 214, 151)',
    borderRadius: 20,
    paddingVertical: 2,
    paddingHorizontal: 10,
    marginHorizontal: 3
  },
  toggleButtonText: {
    color: '#fff',
  },
  includeToggle: {
    textAlign: 'center',
  },
  matchToggle: {
    textAlign: 'center',
  },
  addInputWrapper: {
    paddingHorizontal: 5,
    marginBottom: 10,
  },
  addInputRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  addInputContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#50565F',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#3a3f45',
    paddingHorizontal: 10,
    marginRight: 8,
  },
  addTextInput: {
    flex: 1,
    color: 'white',
    padding: 10,
    fontSize: 14,
  },
  addInputSearchIcon: {
    color: '#A0A0A3',
    fontSize: '20px',
  },
  addButton: {
    width: 36,
    height: 36,
    justifyContent: 'center',
    alignItems: 'center',
  },
  addButtonIcon: {
    color: '#fff',
    fontSize: '20px',
  },
  suggestionsContainer: {
    marginTop: 4,
    backgroundColor: '#3a3f45',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#50565F',
    overflow: 'hidden',
  },
  suggestionsLoadingText: {
    color: '#9BA7B4',
    padding: 10,
    fontSize: 13,
  },
  suggestionRow: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#50565F',
  },
  suggestionText: {
    color: '#fff',
    fontSize: 14,
  },
  // Saved & Favourite Views dropdown
  savedViewsWrapper: {
    marginTop: 0,
  },
  savedViewsContent: {
    padding: 10,
    marginTop: 2,
    alignItems: 'center',
    width: '100%',
  },
  savedViewsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 12,
    width: '100%',
  },
  savedViewsViewButton: {
    width: '48%',
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 8,
    marginBottom: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  savedViewsViewButtonText: {
    color: '#E7ECF3',
    fontSize: 13,
    textAlign: 'center',
  },
  savedViewsSelectEditContainer: {
    marginBottom: 12,
  },
  savedViewsSelectEditRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  savedViewsSelectEditText: {
    color: '#E7ECF3',
    fontSize: 13,
    textDecorationLine: 'underline',
    marginRight: 6,
  },
  savedViewsDropdownChevron: {
    width: 12,
    height: 12,
  },
  savedViewsDropdownChevronOpen: {
    transform: [{rotate: '180deg'}],
  },
  savedViewsSelectEditDropdown: {
    width: '100%',
    backgroundColor: '#283137',
    borderRadius: 8,
    overflow: 'hidden',
    minWidth: 200,
    marginTop: 4,
  },
  savedViewsSelectEditHeader: {
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  savedViewsSelectEditHeaderText: {
    color: '#E7ECF3',
    fontSize: 13,
    fontWeight: 'bold',
  },
  savedViewsSelectEditOptionWithIcon: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  savedViewsSelectEditIcon: {
    color: '#E7ECF3',
    fontSize: 14,
    marginRight: 8,
  },
  savedViewsSelectEditOption: {
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  savedViewsSelectEditOptionText: {
    color: '#E7ECF3',
    fontSize: 13,
    textAlign: 'left',
    fontWeight: 'bold',
  },
  savedViewsSaveButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'max-content',
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 8,
  },
  savedViewsSaveIcon: {
    color: '#E7ECF3',
    fontSize: 18,
    marginRight: 8,
  },
  savedViewsSaveButtonText: {
    color: '#E7ECF3',
    fontSize: 13,
  },
  savedViewsSavePromptOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  savedViewsManageModalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  savedViewsManageModalContent: {
    backgroundColor: '#283137',
    borderRadius: 12,
    width: '90%',
    maxWidth: 480,
    maxHeight: '80%',
  },
  savedViewsSaveModalContent: {
    backgroundColor: '#283137',
    borderRadius: 12,
    width: '90%',
    maxWidth: 480,
    maxHeight: '80%',
    boxShadow: '0 12px 28px rgba(0,0,0,0.35)',
  },
  savedViewsSaveModalBody: {
    paddingVertical: 18,
    paddingHorizontal: 16,
  },
  savedViewsSaveModalInput: {
    color: '#E7ECF3',
    backgroundColor: '#1f272d',
    borderColor: 'rgba(255,255,255,0.18)',
    borderRadius: 6,
    borderWidth: 1,
    fontSize: 14,
    height: 38,
    paddingHorizontal: 10,
    marginBottom: 16,
  },
  savedViewsSaveModalActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: 8,
  },
  savedViewsSaveModalActionButton: {
    alignItems: 'center',
    borderColor: '#849DB8',
    borderRadius: 6,
    borderWidth: 1,
    minHeight: 34,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 7,
  },
  savedViewsSaveModalSecondaryButton: {
    borderColor: 'rgba(255,255,255,0.24)',
  },
  savedViewsSaveModalFavouriteButton: {
    backgroundColor: '#3b4650',
  },
  savedViewsSaveModalActionText: {
    color: '#E7ECF3',
    fontSize: 13,
    fontWeight: 'bold',
  },
  savedViewsManageModalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.1)',
  },
  savedViewsManageModalTitle: {
    color: '#E7ECF3',
    fontSize: 16,
    fontWeight: 'bold',
  },
  savedViewsManageModalCloseBtn: {
    padding: 4,
  },
  savedViewsManageModalCloseIcon: {
    color: '#E7ECF3',
    fontSize: 22,
  },
  savedViewsManageModalList: {
    maxHeight: 400,
  },
  savedViewsManageModalListContent: {
    paddingVertical: 8,
    paddingBottom: 16,
  },
  savedViewsManageModalRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  savedViewsManageModalRowText: {
    color: '#E7ECF3',
    fontSize: 14,
    flex: 1,
    marginRight: 12,
  },
  savedViewsManageModalRowIcons: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  savedViewsManageModalIconBtn: {
    padding: 6,
    marginLeft: 4,
  },
  savedViewsManageModalRowIcon: {
    color: '#E7ECF3',
    fontSize: 18,
  },
  savedViewsManageModalHeartIcon: {
    color: '#E7ECF3',
    fontSize: 18,
  },
});

export default dropdownStyles;
